import React, { useRef } from 'react';
import PropTypes        from 'prop-types';
import classNames       from 'classnames';
import { Link }         from 'react-router-dom';
import ReCAPTCHA        from 'react-google-recaptcha';

import Logo             from '../../../assets/images/logo_black.png';

import useAccountPage   from './useAccountPage';

import AccountTab         from './tabs/AccountTab.js';
import CompanyTab         from './tabs/CompanyTab.js';
import CongratulationsTab from './tabs/CongratulationsTab.js';
import ThanksTab          from './tabs/ThanksTab.js';

import styles           from './AccountPage.styl';

const TABS_TO_NAME = {
    account         : AccountTab,
    company         : CompanyTab,
    congratulations : CongratulationsTab,
    thanks          : ThanksTab
}

function AccountPage() {
    // const { className, children, ...rest } = props;
    const captchaRef = useRef();

    const {
        tab,
        handleChangeTab,
        handleChange,
        handleChangeCase,
        handleSelectChange,
        handleCreateAccount,
        values,
        errors
    } = useAccountPage(captchaRef);

    const TAB = TABS_TO_NAME[tab]

    return  (
        <div
            className = {classNames(styles.AccountPage, {
                [styles.thanks] : tab === 'thanks'
            })}
        >
            <div className={classNames(styles.header, {
                [styles.thanksHeader]: tab === 'thanks'
            })}>
                <Link to='/'>
                    <img
                        src       = {Logo}
                        className = {styles.logo}
                    />
                </Link>
            </div>
            {tab !== 'thanks'
                ? (
                    <div className={styles.dotsWrapper}>
                        <div className={classNames(styles.dot, {
                            [styles.active]: tab === 'account'
                        })}/>
                        <div className={classNames(styles.dot, {
                            [styles.active]: tab === 'company'
                        })}/>
                        <div className={classNames(styles.dot, {
                            [styles.active]: tab === 'congratulations'
                        })}/>
                    </div>
                )
                : null
            }

            <TAB
                onChangeTab    = {handleChangeTab}
                onChange       = {handleChange}
                onChangeCase   = {handleChangeCase}
                onCreate       = {handleCreateAccount}
                onSelectChange = {handleSelectChange}
                values         = {values}
                errors         = {errors}
            />
            <ReCAPTCHA
                ref     = {captchaRef}
                size    = 'invisible'
                sitekey = '6LcKgNMiAAAAAMNYtke87BhLUPtUMB91y3jqg3Q7'
            />
        </div>
    );
}

AccountPage.propTypes = {
    className : PropTypes.string
};

AccountPage.defaultProps = {
    className : ''
};

export default AccountPage;
